import { atom, selector } from "recoil";
import { authorizationQuery } from "./AuthorizationState";

/**
 * ログインユーザ情報
 */
export const userState = atom({
  key: 'userState',
  default: selector({
    key: 'userStateSelector',
    get: ({get}) => {
      const authorization = get(authorizationQuery);
      return {
        id: authorization.loginUser,
        userId: authorization.userId,
        userName: authorization.username,
        customer: authorization.customerCode,
        customerName: authorization.customerName,
        group: authorization.userGroupId,
        groupName: authorization.userGroupName,
        contract: authorization.contractId,
        contractName: authorization.contractName,
        role: authorization.role,
        isAdmin: authorization.isAdmin,
        workspaceId: authorization.workspaceId
      }
    }
  })
});
